import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { HOC } from 'formsy-react';
import Box from '@material-ui/core/Box';
import TextField from 'material-ui/TextField';
import { textFieldStyle, multiLineText } from '../../../theme/AllocateBaseTheme';
import globals from '../../../globals/communityGlobals';

const styles = {
  textAreaDetails: {
    ...multiLineText.style,
    backgroundColor: 'transparent',
    width: '100%',
  },
  textAreaLabelStyle: {
    color: '#00b1eb',
    padding: '0 8px',
    fontSize: 14,
  },

  textAreaInputStyle: {
    marginTop: 0,
    paddingLeft: 8,
    paddingTop: 11,
  },
};

const locale = globals.getArea('treatments');

class AddressForm extends Component {
  handleChange = field => (info, value) => {
    const currentValue = this.props.getValue();
    this.props.setValue({
      ...currentValue,
      [field]: value,
    });

    if (field === 'postCode') {
      if (value !== null && value !== '') {
        this.props.onPostcodeChange(true);
      } else {
        this.props.onPostcodeChange(false);
      }
    }
  };
  render() {
    const { disabled, accessDetailsDisabled } = this.props;
    const {
      addressLine1 = '',
      addressLine2 = '',
      addressLine3 = '',
      townCity = '',
      postCode = '',
      accessDetails = '',
      description = '',
    } = this.props.getValue() || {};

    return (
      <div>
        <Box display="flex" p={1}>
          <Box p={1} flexGrow={1} style={{ width: '33.3%' }}>
            <TextField
              disabled={disabled}
              floatingLabelText={locale.getMsg('addressLine1')}
              onChange={this.handleChange('addressLine1')}
              value={addressLine1 || ''}
              floatingLabelStyle={textFieldStyle.floatingLabelStyle}
              floatingLabelShrinkStyle={textFieldStyle.floatingLabelShrinkStyle}
              style={textFieldStyle.style}
              inputStyle={textFieldStyle.inputStyle}
              underlineStyle={textFieldStyle.underlineStyle}
            />
          </Box>
          <Box p={1} flexGrow={1} style={{ width: '33.3%' }}>
            <TextField
              disabled={disabled}
              floatingLabelText={locale.getMsg('addressLine2')}
              onChange={this.handleChange('addressLine2')}
              value={addressLine2 || ''}
              floatingLabelStyle={textFieldStyle.floatingLabelStyle}
              floatingLabelShrinkStyle={textFieldStyle.floatingLabelShrinkStyle}
              style={textFieldStyle.style}
              inputStyle={textFieldStyle.inputStyle}
              underlineStyle={textFieldStyle.underlineStyle}
            />
          </Box>
          <Box p={1} flexGrow={1} style={{ width: '33.3%' }}>
            <TextField
              disabled={disabled}
              floatingLabelText={locale.getMsg('addressLine3')}
              onChange={this.handleChange('addressLine3')}
              value={addressLine3 || ''}
              floatingLabelStyle={textFieldStyle.floatingLabelStyle}
              floatingLabelShrinkStyle={textFieldStyle.floatingLabelShrinkStyle}
              style={textFieldStyle.style}
              inputStyle={textFieldStyle.inputStyle}
              underlineStyle={textFieldStyle.underlineStyle}
            />
          </Box>
        </Box>
        <Box display="flex" p={1}>
          <Box p={1} flexGrow={1} style={{ width: '33.3%' }}>
            <TextField
              disabled={disabled}
              floatingLabelText={locale.getMsg('townCity')}
              onChange={this.handleChange('townCity')}
              value={townCity || ''}
              className="col-c3"
              floatingLabelStyle={textFieldStyle.floatingLabelStyle}
              floatingLabelShrinkStyle={textFieldStyle.floatingLabelShrinkStyle}
              style={textFieldStyle.style}
              inputStyle={textFieldStyle.inputStyle}
              underlineStyle={textFieldStyle.underlineStyle}
            />
          </Box>
          <Box p={1} flexGrow={1} style={{ width: '33.3%' }}>
            <TextField
              disabled={disabled}
              floatingLabelText={locale.getMsg('postcode')}
              onChange={this.handleChange('postCode')}
              value={postCode || ''}
              className="col-c3"
              floatingLabelStyle={textFieldStyle.floatingLabelStyle}
              floatingLabelShrinkStyle={textFieldStyle.floatingLabelShrinkStyle}
              style={textFieldStyle.style}
              inputStyle={textFieldStyle.inputStyle}
              underlineStyle={textFieldStyle.underlineStyle}
            />
          </Box>
          <Box p={1} flexGrow={1} style={{ width: '33.3%', marginTop: '-36px' }}>
            <TextField
              disabled={disabled && accessDetailsDisabled}
              floatingLabelText={locale.getMsg('accessDetails')}
              onChange={this.handleChange('accessDetails')}
              value={accessDetails || ''}
              style={styles.textAreaDetails}
              floatingLabelStyle={styles.textAreaLabelStyle}
              floatingLabelShrinkStyle={textFieldStyle.floatingLabelShrinkStyle}
              underlineStyle={textFieldStyle.underlineStyle}
              inputStyle={styles.textAreaInputStyle}
              multiLine
              rowsMax={3}
            />
          </Box>
        </Box>
        {this.props.name === 'alternativeAddress' && (
          <Box p={1} flexGrow={1} style={{ width: '33.3%' }}>
            <TextField
              disabled={disabled}
              floatingLabelText={'Address Description'}
              onChange={this.handleChange('description')}
              value={description || ''}
              floatingLabelStyle={textFieldStyle.floatingLabelStyle}
              floatingLabelShrinkStyle={textFieldStyle.floatingLabelShrinkStyle}
              style={textFieldStyle.style}
              inputStyle={textFieldStyle.inputStyle}
              underlineStyle={textFieldStyle.underlineStyle}
            />
          </Box>
        )}
      </div>
    );
  }
}

AddressForm.defaultProps = {
  defaultValue: {},
  disabled: false,
  onPostcodeChange: () => {},
  accessDetailsDisabled: true,
};

AddressForm.propTypes = {
  setValue: PropTypes.func.isRequired,
  getValue: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  onPostcodeChange: PropTypes.func,
  accessDetailsDisabled: PropTypes.bool,
};

export default HOC(AddressForm);
